// @flow
import { Units } from 'common/enums/UnitEnum';
export const units = {
    volume: {
        preferredUnits: [Units.list.volume.CubicMeter],
        sourceUnit: Units.list.volume.CubicMeter
    },
    dimensions: {
        preferredUnits: [Units.list.length.Meter],
        sourceUnit: Units.list.length.Meter
    }
};
